<template>
  <section>
    <div v-if="step == 1">
      <div v-for="c in joinedCourseGroups" :key="c.id">
        <div
          class="flex bg-green-light text-white justify-between items-center p-2 pl-3 rounded-lg mb-2"
        >
          <div class="flex flex-col py-1 px-2 tracking-wider">
            <p class="font-bold">
              Start:
              <span class="pl-2">
                {{ getFormattedDate(c.start_date, c.timezone, 'MMM DD, YYYY') }}
              </span>
            </p>
            <p class="font-bold">
              End:
              <span class="pl-4">
                {{ getFormattedDate(c.end_date, c.timezone, 'MMM DD, YYYY') }}
              </span>
            </p>
          </div>
          <button
            type="button"
            class="bg-white text-green-light ring-gray-300 py-2 px-6 text-gray-dark ring-1 rounded-lg"
            @click="viewCourseSessionHandler(c.group_id)"
          >
            See Details
          </button>
        </div>
      </div>
      <p
        class="text-sm text-center text-gray-dark"
        v-if="joinedCourseGroups && joinedCourseGroups.length == 0"
      >
        You haven't joined any classes for this class pack
      </p>
    </div>

    <div v-if="step == 2">
      <div v-for="s in sessions_group" :key="s.id">
        <div class="flex justify-between items-center py-2">
          <div class="text-gray-800">
            <p class="text-sm text-gray-350">
              {{ getFormattedDate(s.start_date, s.timezone, 'MMM DD, YYYY (ddd)') }}
            </p>
            <p class="text-xs text-gray-350">
              {{ getFormattedDate(s.start_date, s.timezone, 'h:mm A') }}-
              {{ getFormattedDate(s.end_date, s.timezone, 'h:mm A') }}
            </p>
          </div>
          <div>
            <button
              type="button"
              class="uppercase bg-green-light rounded py-2 px-3 text-white text-sm"
              @click="$emit('sessions-group', sessions_group)"
              v-if="s.joining_status == 1"
            >
              Payment Pending
            </button>
            <button
              class="disabled h-8 px-4 m-2 text-sm text-white cursor-not-allowed opacity-50 transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none"
              v-else-if="[0, 3].includes(s.status) || s.transaction_status === 'refunded'"
            >
             {{getSessionStatus(s.transaction_status === 'refunded' ? 0 : s.status)}}
            </button>
            <button
              v-else
              class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none"
              :disabled="s.disableStatus"
              @click="sessionBookingHandler(s.id, s.status)"
            >
              {{getSessionStatus(s.status)}}
            </button>
            <!-- @click="sessionBookingHandler(d.id, d.status)" -->
          </div>
        </div>
      </div>
      <p
        class="text-sm text-center py-2 text-gray-dark"
        v-if="sessions_group && sessions_group.length == 0"
      >
        No slots available or scheduled for this class
      </p>
      <div class="flex">
        <button
          class="ring-gray-dark ring-1 w-full rounded-lg py-2"
          @click="handleCancel"
        >
          Back
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters } from "vuex";
import TipPaymentModal from "@/components/t-components/TipPaymentModal";
import Vue from 'vue';
import "@/assets/css/bootstrap.css";
import moment from 'moment-timezone';

export default {
  name: "CourseGroupsJoined",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      step: 1,
      sessions_group: [],
      courseInterval: null,
      sdkKey: "JN61VXxPXfzVSUo8dSeFa2yTUBkCywpvmO2I"
    };
  },
  watch: {
    isValidSession (res) {
      // [1, 2] refer getSessionStatus for statuses
      if (res && res.data && res.data.status && [1, 2].includes(res.data.status)) {
        this.activateZoomHandler(res.data.session_id, res.data.id)
      } else if (res && res.statusCode && res.statusCode === 386) {
        this.$store.commit('setError', {title: "Alert", text: res.message})
        this.$store.commit('setIsLoading', false)
      }
    }
  },
  computed: {
    ...mapGetters([
      "isValidSession",
      "livestreamSessionBatch",
      "userProfile"
    ]),
    joinedCourseGroups () {
      return this.data && this.data.course_groups && this.data.course_groups.joined && this.data.course_groups.joined.data;
    },
    joinedSessionsForCourses () {
      return this.data && this.data.sessions_group && this.data.sessions_group.joined;
    },
    getTrainerAccountId () {
      return this.data && this.data.course && this.data.course.details && this.data.course.details.trainer_account_id
    },
    getUserTimeToJoin () {
      return this.data && this.data.course && this.data.course.details && this.data.course.details.time_to_join
    }
  },
  beforeDestroy() {
    clearInterval(this.courseInterval);
  },
  methods: {
    viewCourseSessionHandler(courseGroupId) {
      let sessionsData = this.extractCourseSessions(courseGroupId)
      if (sessionsData && sessionsData.length) {
        this.sessions_group = [...sessionsData]
        this.sessions_group.map((itm) => {
          itm.disableStatus = true
          return itm
        })
        this.step = 2;
        this.$emit("hide-slot", false);
        this.sessionStartCounter(this.sessions_group)
      } else {
        this.$store.commit('setError', {title: "Alert", text: 'No Sessions found for this class pack'})
      }
    },
    extractCourseSessions (courseGroupId) {
      return this.joinedSessionsForCourses && this.joinedSessionsForCourses[courseGroupId]
    },
    userReviewHandler (sessionValue, batchValue) {
      localStorage.setItem("sessionReview", JSON.stringify({sessionId: sessionValue, batchId: batchValue}));
    },
    handleCancel() {
      this.step = 1;
      clearInterval(this.courseInterval);
      this.$emit("show-slot", true);
    },
    getSessionStatus (status) {
      switch (status) {
        case 3:
          return 'Ended';
        case 2:
          return 'Join Class';
        case 1:
          return 'Upcoming'
        case 0:
          return 'Canceled';
        case 4:
          return 'Start'
        default:
          return 'Loading';
      }
    },
    sessionStartCounter(sessionGroupData) {
      let timeToJoin = Number(window.config.VUE_APP_TIME_TO_JOIN_IN_MINUTES);
      let userTimeZone = this.getTimeZone();
      const getUserTimeToJoin = this.getUserTimeToJoin;
      this.courseInterval = setInterval(function () {
        sessionGroupData.forEach((batch) => {
          // Convert the start_date and time to a Moment object in the batch timezone.
          let startTimeMoment = moment.tz(batch.start_date, batch.timezone);
          let endTimeMoment = moment.tz(batch.end_date, batch.timezone);
          // Get the date and time in Viewer's timezone.
          let viewerStartTime = startTimeMoment.tz(userTimeZone);
          let viewerEndTime = endTimeMoment.tz(userTimeZone);
          // Get the current time in the local timezone.
          let localDateTime = moment();
          // Convert the local time into Viewer's timezone.
          let viewerCurrTime = moment.tz(localDateTime, userTimeZone);
          // Get the difference between the start time and the current time in the viewer's timezone in minutes.
          const duration = moment.duration(viewerStartTime.diff(viewerCurrTime)).asMinutes();
          const ended = viewerEndTime.diff(viewerCurrTime)
          if ((duration <= timeToJoin || getUserTimeToJoin) && !([0, 3].includes(batch.status))) {
            batch.status = 4 //locally maintained by frontend
            batch.disableStatus = false
          }
          if(ended < 0 && batch.status !== 0){
            batch.status = 3
            batch.disableStatus = true
          }
        })
      }, 1000);
    },
    async sessionBookingHandler (batchId, batchStatus) {
      if (batchStatus && (batchStatus === 4 || batchStatus === 2)) {
        this.$store.commit('setIsLoading', true)
        await this.$store.dispatch('validateSession', batchId).catch((err) => {
          this.$store.commit('setIsLoading', false)
          this.$store.commit('setError', {title: "Alert", text: err.message})
        })
        // watcher isValidSession will act on success
      }
    },
    async activateZoomHandler (sessionId, batchId) {
      await this.$store.dispatch('getLivestreamSessionBatch', batchId).catch((err) => {
        this.$store.commit('setIsLoading', false)
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
      const meeting = this.livestreamSessionBatch && this.livestreamSessionBatch.meeting;
      if (meeting && meeting.meeting_link) {
        //verifying zoom signature
        await this.$store.dispatch('getZoomSignature', {
          meetingNumber: meeting.meeting_id,
          role: 0,
        }).then((res) => {
          this.userReviewHandler(sessionId, batchId)
          res && res.signature && res.signature.length ? this.meetingInitializer(meeting, res.signature, batchId) : this.$store.commit('setError', {title: "Alert", text: 'Session Initialization failed, try again'})
        }).catch((err) => {
          this.$store.commit('setIsLoading', false)
          this.$store.commit('setError', {title: "Alert", text: err.message})
        })
      } else {
        this.$store.commit('setError', {title: "Alert", text: 'Session is Un-available'})
      }
    },
    async meetingInitializer (meeting, signature, batchId) {
      const {ZoomMtg} = await import("@zoomus/websdk");
      ZoomMtg.setZoomJSLib("https://source.zoom.us/2.13.0/lib", "/av");
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareWebSDK();
      ZoomMtg.i18n.load("en-US");
      ZoomMtg.i18n.reload("en-US");
      ZoomMtg.init({
        leaveUrl: window.location.href,
        success: (success) => {
          this.$store.commit('setIsLoading', false)
          this.$store.commit('setChatBotVisibility', false)
          ZoomMtg.join({
            meetingNumber: meeting && meeting.meeting_id,
            userName: this.userProfile && this.userProfile.personal_details && this.userProfile.personal_details.email,
            signature: signature,
            sdkKey: this.sdkKey,
            userEmail: this.userProfile && this.userProfile.personal_details && this.userProfile.personal_details.email,
            passWord: meeting && meeting.meeting_password,
            tk: "", // this.registrantToken
            success: (success) => {
              // console.log(success);

              const mountNode = document.createElement("div");
              mountNode.id = "mount-node";
              document.getElementById("zmmtg-root").appendChild(mountNode);

              var ComponentClass = Vue.extend(TipPaymentModal);
              const dataObj = {
                paymentModal: false,
                stripe: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID, {
                  stripeAccount: this.getTrainerAccountId
                }),
                stripe1: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID),
                // The items the customer wants to buy
                elements: {},
                nameOnCard: null,
                amount: 5,
                message: null,
                paymentMethodId: null,
                clientSecret: null,
                isProcessing: false,
                isNewCard: false,
                isUserCard: false,
                userCardList: [],
                cardNumberElement: null,
                cardExpiryElement: null,
                cardCvcElement: null,
                trainer_account_id: this.getTrainerAccountId,
                batchId: batchId
              };
              var instance = new ComponentClass({
                data() {
                  return dataObj;
                },
              });
              instance.$mount("#mount-node");
            },
            error: (error) => {
              console.log(error);
            },
          });
        },
        error: (error) => {
          console.log(error);
          this.$store.commit('setIsLoading', false)
        },
      });
    }
  }
};
</script>